import { useSelector } from "react-redux";
import { useCallback } from "react";

/**
 * Returns a function that gets the translated value from an object
 * with { en: "...", fr: "..." } or { name_en: "...", name_fr: "..." } keys,
 * based on the current locale. The returned function will update when the locale changes.
 */
const useTranslatedValue = () => {
  const locale = useSelector((state) => state.domain.locale.lang || "en");

  return useCallback(
    (obj, fallback = "") => {
      if (!obj) return fallback;
      // Try plain keys
      if (obj[locale]) return obj[locale];
      // Try name_ keys
      if (obj[`name_${locale}`]) return obj[`name_${locale}`];
      // Fallbacks
      return fallback;
    },
    [locale],
  );
};

export default useTranslatedValue;
